/* eslint-disable */

import { getAppTitle } from '@/scripts/root/appTitle'

const setMeta = (doc: Document, data: { title?: string } = {}) => {
  doc.title = data.title || getAppTitle()
}

export default setMeta
